<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :tilingActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "tilling",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "tilling/IMG-20180304-WA0005.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "tilling/IMG-20180315-WA0010.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "tilling/IMG-20180304-WA0002.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "tilling/IMG-20180304-WA0003.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      }
    ],
    serviceTitle: "Tilling",
    serviceDescription:
      "We offer floor and wall tilling for commercial and domestic properties. Wet room and pool, stone ,porcelains, ceramic floor and wall, stone cladding and fine ravens."
  })
};
</script>
